import { Component, Output, ViewChild, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import {DialogComponent} from '../dialog/dialog.component';

@Component({
    selector: 'app-error-modal',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    exportAs: "bs-modal",
})
export class ErrorComponent {
    @ViewChild('dialog')
    private dialog: DialogComponent;


    public errorMessage: string;
    public statusCode: number;

    @Output() onHide = new EventEmitter();

    constructor(
        private router: Router,
    ) {
    }

    show(errorMessage: string, statusCode: number) {
        this.dialog.onHide.subscribe((reason: any) => {
            this.onHide.next(reason);
        });

        this.errorMessage = errorMessage;
        this.statusCode = statusCode;
        this.dialog.showModal();
    }

    hide() {
        if (this.statusCode === 401) {
            this.router.navigate(['/auth'], { queryParams: { returnUrl: this.router.url } });
        }
        this.dialog.close();
    }
}
